<script lang="ts" setup>
import BusinessAppTour from '@/presentation/components/common/business-tour/BusinessAppTour.vue';
</script>

<template>
	<div class="min-h-screen bg-gray-100">
		<main data-business-tour="content" class="w-full min-h-screen mx-auto">
			<slot />
		</main>
		<BusinessAppTour />
	</div>
</template>
